module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("I settled into the second guest chair, then immediately wanted to scoot myself away from the man next to me. Power, an almost physical force, surged around him.")]), _vm._v(" Nothing wimpy like static that would raise a small sprinkling of goose bumps on my arm. No, this was overwhelming, like standing next to a man-sized speaker at a death metal concert. It felt like something writhed under my skin. Not painful, but a little uncomfortable in its unexpectedness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“This is Ford Whitney, one of our graduate students.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("It took me a moment to clear the fuzz in my brain and realize Tierney was introducing me to the guy next to me. Ford. The name fit him. Strong. Straightforward. Sexy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("I needed to stop that kind of thinking right now. The strikes were already piling up against me. Lustful thoughts about one of the grad students was a big no-no.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0